import { Component, OnInit, ChangeDetectorRef, ViewChild, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { ExceptionHelper } from './../../../../helper';
import { IsActive } from './../../../../model';
import { DatePipe } from '@angular/common';

import { ServiceCallSummaryService } from './service-call-summary.service';

import * as $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4';

@Component({
  selector: 'app-service-call-summary',
  templateUrl: './service-call-summary.component.html',
  styleUrls: [
    '../../../../../scss/vendors/bs-datepicker/bs-datepicker.scss'
  ],
  encapsulation: ViewEncapsulation.None
})
export class ServiceCallSummaryComponent implements OnInit, AfterViewInit {

  @ViewChild('dangerModal') dangerModal: any;

  @ViewChild('arranging') private arrangingCheckbox;
  @ViewChild('confirmed') private confirmedCheckbox;
  @ViewChild('completed') private completedCheckbox;
  @ViewChild('cancelled') private cancelledCheckbox;
  @ViewChild('dateRange') private dateRangeCheckbox ;

  // for managing checkboxes
  arranging: any;
  confirmed: any;
  completed: any;
  cancelled: any;
  dateRange: any;

  isArranging = false;
  isConfirmed = false;
  isCompleted = true;
  isCancelled = false;
  isDateRange = false;
  applied: Boolean = true;

  // for setting default date of ngbDatePicker
  today: Date = new Date();
  startOFmonth: Date = new Date();
  lastMonth: Date = new Date();
  todayFM: String;
  startOFmonthFM: String;
  lastMonthFM: String;
  startDate: String;
  endDate: String;
  bsRangeValue: any;

  services: any[];
  dataTable: any;

  customerId;

  constructor(
    private chRef: ChangeDetectorRef,
    private exception: ExceptionHelper,
    private datePipe: DatePipe,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private serviceCallSummaryService: ServiceCallSummaryService,
    private translateService: TranslateService) {
    translateService.setDefaultLang('en-us');
    this.route.params.subscribe(params => { this.customerId = params['customerId']; });

  }

  ngAfterViewInit() {
    this.arranging = this.arrangingCheckbox.nativeElement;
    this.confirmed = this.confirmedCheckbox.nativeElement;
    this.completed = this.completedCheckbox.nativeElement;
    this.cancelled = this.cancelledCheckbox.nativeElement;
    this.dateRange = this.dateRangeCheckbox.nativeElement;

    this.getSummary('', '', IsActive.inactive, IsActive.inactive, IsActive.active, IsActive.inactive);
  }

  ngOnInit() {
    // set ngbDatePicker default value
    this.startOFmonth.setDate(1);
    this.lastMonth.setMonth(this.lastMonth.getMonth() - 1);
    this.bsRangeValue = [];
    this.todayFM = this.datePipe.transform(this.today, 'yyyy-MM-dd'),
      this.startOFmonthFM = this.datePipe.transform(this.startOFmonth, 'yyyy-MM-dd'),
      this.lastMonthFM = this.datePipe.transform(this.lastMonth, 'yyyy-MM-dd'),
      this.startDate = this.lastMonthFM;
    this.endDate = this.todayFM;
  }

  apply() {
    this.isArranging = this.arranging.checked;
    this.isConfirmed = this.confirmed.checked;
    this.isCompleted = this.completed.checked;
    this.isCancelled = this.cancelled.checked;
    this.isDateRange = this.dateRange.checked;

    // setting params for api
    const para_arranging = (this.arranging.checked === true ? IsActive.active : IsActive.inactive);
    const para_confirmed = (this.confirmed.checked === true ? IsActive.active : IsActive.inactive);
    const para_completed = (this.completed.checked === true ? IsActive.active : IsActive.inactive);
    const para_cancelled = (this.cancelled.checked === true ? IsActive.active : IsActive.inactive);

    // add params later
    if (this.isDateRange && this.bsRangeValue.length === 2) {
      this.getSummary(this.datePipe.transform(this.bsRangeValue[0], 'yyyy-MM-dd'),
      this.datePipe.transform(this.bsRangeValue[1], 'yyyy-MM-dd'),
      para_arranging, para_confirmed, para_completed, para_cancelled);
    } else {
      this.getSummary('', '',
        para_arranging, para_confirmed, para_completed, para_cancelled);
    }

  }

  filterChange() {
    if (this.isArranging === this.arranging.checked && this.isConfirmed === this.confirmed.checked &&
      this.isCompleted === this.completed.checked && this.isCancelled === this.cancelled.checked &&
      this.startDate === this.datePipe.transform(this.bsRangeValue[0], 'yyyy-MM-dd') &&
      this.endDate === this.datePipe.transform(this.bsRangeValue[1], 'yyyy-MM-dd')) {
      // unchanged
      this.applied = true;
    } else if (this.arranging.checked || this.confirmed.checked || this.completed.checked || this.cancelled.checked) {
      this.applied = false;
    } else {
      this.applied = true;
    }
    this.applied = this.dateRange === this.dateRange.checked;

  }

  getSummary(startDate, endDate, arranging, confirmed, completed, cancelled) {
    const all = (this.customerId == null ? true : false);

    this.serviceCallSummaryService.getSummary(startDate, endDate, arranging, confirmed, completed, cancelled, all, this.customerId)
      .subscribe((data: any) => {
        this.applied = true;
        if ($.fn.dataTable.isDataTable('#serviceDataTables')) { $('#serviceDataTables').DataTable().destroy(); }

        this.services = data.serviceCallDetailListModel;
        // for (const service of this.services) {
        //   service.creationTime = service.creationTime.substr(0, 10);
        // }

        this.chRef.detectChanges();

        const table: any = $('#serviceDataTables');
        this.dataTable = table.DataTable({
          'order': [3, 'desc']
        });
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
      });
  }
  public onDateRangeChange(): void {
    this.applied = !(this.dateRange.checked === true);
  }

  errorClose() {
    if (this.customerId != null) {
      this.router.navigate(['/home/customers/detail/' + this.customerId]);
    }
    else {
      this.dangerModal.hide();
    }

  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/service-call/service-call-summary/service-call-summary.component.ts